<template lang="pug">
  .app-wrapper(v-if="loaded", :style="{...cssVars, 'background-image': backgroundImage }")
    div(v-if="!iFrameMode")
      img.custom-logo(v-if="whiteLabel.logoUrl", :src="whiteLabel.logoUrl")
      img.black-logo(v-else-if="!isNoValidUserPage" src="@/assets/images/logo-v3.svg")
      .terms-wrapper
        terms-of-service(v-if="!isMobile", :spacing="true")
    nuxt
</template>

<script>

import smoothscroll from 'smoothscroll-polyfill';
import moment from 'moment-timezone';

import { mapActions } from 'vuex';
import { browserUnsupported } from '@/utils/browser';
import TermsOfService from '@/components/terms-of-service';
import cssMixin from '@/components/mixins/css-vars';
import iframeUtils from '@/components/mixins/iframe-utils';
import mobileDetector from '@/components/mixins/mobile-detector';
import * as WhiteLabel from '@/store/white-label';

smoothscroll.polyfill();

export default {
  mixins: [cssMixin, iframeUtils, mobileDetector],
  components: {
    TermsOfService
  },
  data() {
    return {
      loaded: false
    };
  },
  watch: {
    $route(from, to) {
      this.updateLocale();
    }
  },
  computed: {
    backgroundImage() {
      return `url(${this.cssVars['--background-image-url']})`;
    },
    isNoValidUserPage() {
      return this.$route.path.includes('no-valid-users');
    }
  },
  methods: {
    ...mapActions(WhiteLabel.type, {
      getWhiteLabel: WhiteLabel.GET
    }),
    updateMomentLocale() {
      moment.updateLocale('en', {
        longDateFormat: {
          LT: 'hh:mm a'
        }
      });
    },
    updateLocale() {
      const language = this.$route.query.lang;
      if (language) {
        this.$i18n.setLocale(language);
      }
    },
    redirectIfBrowserUnsupported() {
      const { name } = this.$route;

      if (browserUnsupported() && name !== 'unsupported-browser') {
        this.$router.push({
          path: '/book/browser-not-supported',
          query: { ...this.$route.query }
        });
      }
    }
  },
  created() {
    this.updateLocale();
  },
  async mounted() {
    this.redirectIfBrowserUnsupported();
    this.updateMomentLocale();
    const { slug } = this.$route.params;

    await this.getWhiteLabel({ slug });

    this.loaded = true;
  }
};

</script>

<style lang="scss">
@import "assets/styles/application.scss";

.black-logo {
  position: absolute;
  top: 25px;
  left: 25px;
}

.custom-logo {
  height: 40px;
  position: absolute;
  top: 24px;
  left: 24px;

  @include mobile() {
    left: 24px;
    top: 16px;
  }
}

.terms-wrapper {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.el-loading-spinner {
  .path {
    stroke: var(--primary-color);
  }

  .el-loading-text {
    color: var(--primary-color);
  }
}

.app-wrapper {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.avatar {
  height: 90px;
  width: 90px;
  border-radius: 45px;
  object-fit: cover;
}

.container {
  max-width: 900px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  @include small-screen;
}

</style>
